import Immutable from 'immutable';

import { UPDATE_CONTINUE_WATCHING_ITEMS } from '../actions/continueWatching';
import { createDeepEqualSelector } from '../utils/redux';

// Match last part with continueWatching action
const CONTINUE_WATCHING = 'continueWatching';
const CONTINUE_WATCHING_ACTIVE = 'active';
const CONTINUE_WATCHING_ITEMS = 'items';

export const continueWatchingActiveSelector = (state) =>
    state.getIn([CONTINUE_WATCHING, CONTINUE_WATCHING_ACTIVE], true);

export const continueWatchingPositionForVideo = (state, videoId) => {
    if (continueWatchingActiveSelector(state) === false) {
        return 0;
    }

    const items = continueWatchingItemsSelector(state);

    const item = items.find((item) => {
        return item.get('videoId') === videoId;
    });

    return item && !item.get('ended') ? item.get('position') : 0;
};

export const continueWatchingForTitle = (state, titleArticleId) => {
    const items = continueWatchingItemsSelector(state);

    return items.filter((item) => {
        return item.get('titleArticleId') === titleArticleId;
    });
};

const getItems = (state) => state.getIn([CONTINUE_WATCHING, CONTINUE_WATCHING_ITEMS], Immutable.List());
const getFilterDeleted = (state, filterDeleted) => filterDeleted;

export const continueWatchingItemsSelector = createDeepEqualSelector(
    [getItems, getFilterDeleted],
    (items, filterDeleted = true) => {
        if (filterDeleted) {
            return items.filter((item) => {
                return item.get('deleted') !== true;
            });
        }

        return items;
    }
);

const initialState = Immutable.fromJS({
    active: true,
    items: [],
});

export default function continueWatching(state = initialState, action) {
    switch (action.type) {
        case UPDATE_CONTINUE_WATCHING_ITEMS: {
            let continueWatching = state.getIn([]);
            for (let key of Object.keys(action.payload)) {
                continueWatching = continueWatching.set(key, Immutable.fromJS(action.payload[key]));
            }

            return state.setIn([], continueWatching);
        }
        default:
            return state;
    }
}
